<template>
    <div v-loading="loading">
        <div v-for="(item, index) in newsletterItems">
            <h4 class="mb-0 mt-0">
                Newsletter - {{ item.orderable.formatted_month }}
            </h4>
            <template v-if="editable">
                <el-button
                    @click="downloadItem(item)"
                    icon="mdi mdi-download"
                    size="mini"
                    type="text"
                >
                    Download
                </el-button>
                <el-button
                    @click="downloadPlainText(item)"
                    icon="mdi mdi-download"
                    size="mini"
                    type="text"
                >
                    Plain Text
                </el-button>
                <el-button
                    @click="downloadImages(item)"
                    icon="mdi mdi-download"
                    size="mini"
                    type="text"
                    v-if="item.orderable.image_count > 0"
                >
                    Images
                </el-button>
            </template>
            <div class="pl-20">
                <div>
                    {{ order.newsletter_type_name }} <br />
                    Quantity:
                    <span v-if="!can(Permissions.EDIT_ORDER_QUANTITY)">{{
                        item.quantity
                    }}</span>
                    <el-input-number
                        v-model="item.quantity"
                        :min="1"
                        :max="1000"
                        :controls="false"
                        name="'newsletterQuantity' + index"
                        size="small"
                        key="index"
                        v-if="can(Permissions.EDIT_ORDER_QUANTITY)"
                        >{{ item.quantity }}</el-input-number
                    >
                </div>
                <div v-if="item.orderable.image_count">
                    Uploaded Photos: {{ item.orderable.image_count }}
                </div>
                <div v-for="file in item.digital_files.data">
                    {{ file.digital_file.name }} -
                    {{ file.digital_file.description }}
                </div>
            </div>
            <table class="w-full" style="max-width: 320px">
                <tbody>
                    <tr v-if="item.birthday_posters.data.length">
                        <th class="text-left">Birthday Posters</th>
                    </tr>
                    <tr v-for="poster in item.birthday_posters.data">
                        <td>
                            {{ poster.name }} -
                            {{ poster.formatted_birth_date }}
                        </td>
                    </tr>
                    <tr v-if="item.printed_extras.data.length">
                        <th class="text-left">Printed Extras</th>
                    </tr>
                    <tr v-for="extra in item.printed_extras.data">
                        <td>{{ extra.quantity }} - {{ extra.description }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-for="item in calendarItems">
            <h4 class="mb-0 mt-10">
                {{ item.orderable.name }} Calendar -
                {{ item.orderable.formatted_month }}
                <div v-if="editable">
                    <el-button
                        @click="editItem(item)"
                        icon="mdi mdi-pencil"
                        size="mini"
                        type="text"
                        v-if="can(Permissions.EDIT_ORDER_CLIENT_CONTENT)"
                    >
                        Edit
                    </el-button>
                    <el-button
                        @click="downloadItem(item)"
                        icon="mdi mdi-download"
                        size="mini"
                        type="text"
                    >
                        Download
                    </el-button>
                    <el-button
                        icon="mdi mdi-file-restore"
                        size="mini"
                        type="text"
                        v-if="order.is_closed"
                        @click="regenerateFinalPdf(item.orderable)"
                        :loading="isItemBusy(item.orderable, 'regenerate')"
                    >
                        Regenerate Final PDF
                    </el-button>
                </div>
            </h4>
            <div class="pl-20">
                <table class="w-full" style="max-width: 320px">
                    <thead>
                        <tr>
                            <td
                                class="font-weight-600 border-bottom"
                                style="width: 85px"
                            >
                                Size
                            </td>
                            <td
                                class="font-weight-600 border-bottom"
                                style="width: 60px"
                            >
                                Qty.
                            </td>
                            <td class="font-weight-600 border-bottom">Color</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(order_size, index) in item.sizes.data">
                            <td>{{ order_size.size.name }}</td>
                            <td>
                                <span
                                    v-if="!can(Permissions.EDIT_ORDER_QUANTITY)"
                                    >{{ order_size.quantity }}</span
                                >
                                <el-input-number
                                    v-model="order_size.quantity"
                                    :min="1"
                                    :max="1000"
                                    :controls="false"
                                    name="'calendarQuantity' + index"
                                    size="small"
                                    key="index"
                                    v-if="can(Permissions.EDIT_ORDER_QUANTITY)"
                                    >{{ order_size.quantity }}</el-input-number
                                >
                            </td>
                            <td>{{ order_size.color_options }}</td>
                        </tr>
                    </tbody>
                </table>
                <table class="w-full" style="max-width: 320px">
                    <tbody>
                        <tr v-if="item.digital_files.data.length">
                            <th class="text-left">Digital Files</th>
                        </tr>
                        <tr v-for="file in item.digital_files.data">
                            <td>
                                {{ file.description }}
                            </td>
                        </tr>
                        <tr v-if="item.birthday_posters.data.length">
                            <th class="text-left">Birthday Posters</th>
                        </tr>
                        <tr v-for="poster in item.birthday_posters.data">
                            <td>
                                {{ poster.name }} -
                                {{ poster.formatted_birth_date }}
                            </td>
                        </tr>
                        <tr v-if="item.printed_extras.data.length">
                            <th class="text-left">Printed Extras</th>
                        </tr>
                        <tr v-for="extra in item.printed_extras.data">
                            <td>
                                {{ extra.quantity }} - {{ extra.description }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="order.free_monthly_posters">
            <h4 class="mb-0 mt-10">Free Items</h4>
            <div class="pl-20">
                <table class="w-full" style="max-width: 320px">
                    <tbody>
                        <tr>
                            <td>
                                <b>{{ order.free_monthly_posters }}</b> Set of
                                Monthly Holiday Posters
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="mb-0 mt-10" v-if="can(Permissions.EDIT_ORDER_QUANTITY)">
            <el-button
                @click="updateOrderQuantity()"
                icon="mdi mdi-content-save"
                type="primary"
            >
                Save Changes
            </el-button>
        </div>
    </div>
</template>

<script>
import * as OrderableTypes from "@/constants/orderable-types";
import auth from "@/mixins/auth";

export default {
    mixins: [auth],
    props: {
        order: {
            required: true,
            type: Object,
        },
        editable: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            OrderableTypes,
            loading: false,
            items: [],
        };
    },
    computed: {
        calendarItems() {
            return this.items.filter(
                (item) => item.orderable_type === OrderableTypes.CALENDAR,
            );
        },
        newsletterItems() {
            return this.items.filter(
                (item) => item.orderable_type === OrderableTypes.NEWSLETTER,
            );
        },
    },
    mounted() {
        this.getData();
        //console.log(this.order);
    },
    watch: {
        "order.id"() {
            this.getData();
        },
    },
    methods: {
        getData() {
            this.loading = true;
            axios
                .get(`/web-api/order/${this.order.id}`, {
                    params: {
                        include:
                            "items.orderable,items.location,items.sizes.size,items.digital_files,items.printed_extras,items.birthday_posters",
                    },
                })
                .then((response) => {
                    if (response.data.id !== this.order.id) {
                        return;
                    }
                    this.items = response.data.items.data;
                    //console.log(this.items);
                })
                .finally(() => (this.loading = false));
        },
        downloadItem(item) {
            window.open(
                `/web-api/${
                    item.orderable_type === OrderableTypes.CALENDAR
                        ? "calendar"
                        : "newsletter"
                }/${item.orderable_id}/download`,
                "_blank",
            );
        },
        downloadPlainText(item) {
            window.open(
                `/web-api/newsletter/${item.orderable_id}/download-plain-text`,
                "_blank",
            );
        },
        editItem(item) {
            this.$router.push({
                name: "EditOrder",
                params: {
                    id: this.order.id,
                },
                query: {
                    item_id: item.orderable_id,
                },
            });
        },
        downloadImages(item) {
            window.open(
                `/web-api/newsletter/${item.orderable.id}/download-images`,
                "_blank",
            );
        },
        regenerateFinalPdf(calendar) {
            this.$confirm("Confirm regenerate final pdf?", "Confirmation", {
                confirmButtonText: "Yes",
                cancelButtonText: "Cancel",
                type: "info",
            })
                .then(() => {
                    this.addBusyItem(calendar, "regenerate");
                    axios
                        .post(
                            `/web-api/calendar/${calendar.id}/regenerate-final-pdf`,
                        )
                        .then(() => {
                            this.$notify.success({
                                message:
                                    "A job has been dispatched to regenerate finalized pdf for the calendar.",
                            });
                        })
                        .finally(() =>
                            this.removeBusyItem(calendar, "regenerate"),
                        );
                })
                .catch((error) => {
                    consle.log(error);
                });
        },
        updateOrderQuantity() {
            this.loading = true;
            axios
                .put(`/web-api/order/${this.order.id}/update-quantity`, {
                    newsletterItems: this.newsletterItems,
                    calendarItems: this.calendarItems,
                })
                .then(() => {
                    this.$notify.success({
                        message: "Order quantity updated successfully.",
                    });
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                    this.getData();
                });
        },
    },
};
</script>
